module.exports = __webpack_public_path__ + "img/@logo_hhgall@3x.84906a86.png";